import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Card, CardBody, Row, Col } from 'reactstrap';
import forms from 'constants/forms';
import { showResult } from 'utils';
import common from 'constants/common';
import AutoCompleteClinics from 'components/molecules/autocompleteFilter/clinic';
import AutoCompleteDoctor from 'components/molecules/autocompleteFilter/doctor';
import DownloadRoundedIcon from 'components/atoms/icons/downloadRoundedIcon';
import withLoader from 'components/organisms/withLoader';
import InsTypeChart from './insTypeChart';
import FulfillmentChart from './fulfillmentChart';

const practiceStats = ({ statusBlocks, insuranceBlocks, patients }) => {
  const DEFAULT_CLINIC_FILTER = forms.clinicFilterOptions[0];
  const DEFAULT_DOCTOR_FILTER = forms.doctorFilterOptions[0];
  const clinicsFilter = DEFAULT_CLINIC_FILTER;
  const doctorsFilter = DEFAULT_DOCTOR_FILTER;
  const { getOnboardingCsvReport: csvLoading } = useSelector(
    (state) => state.loading.effects.onboardingStatus,
  );
  const {
    onboardingStatus: {
      setClinicOnboardingStatus,
      setDoctorOnboardingStatus,
      resetFilters,
      getOnboardingCsvReport,
    },
  } = useDispatch();

  const { clinic } = useSelector((state) => state.onboardingStatus);
  const onClinicChange = (value) => {
    setClinicOnboardingStatus(value?.value);
  };
  const onDoctorChange = (value) => {
    setDoctorOnboardingStatus(value?.value);
  };
  const sendReport = async () => {
    const { error } = await getOnboardingCsvReport();
    return showResult(error, common.submitSuccessTypes.sendReport);
  };

  useEffect(
    () => () => {
      resetFilters();
    },
    [],
  );

  return (
    <div className="onboarding-table">
      <Card className="card-border">
        <CardBody>
          <div className="performance-review__header">
            <Row>
              <Col xs={12} lg={4}>
                <div className="onboarding-status">
                  <div className="onboarding-title">
                    Report: Onboarding Status
                  </div>
                  <Col xs={12} lg={12}>
                    <div>
                      <p>Clinics</p>
                      <AutoCompleteClinics
                        filter={clinicsFilter}
                        handleClick={onClinicChange}
                      />
                    </div>
                  </Col>
                  {clinic && (
                    <Col xs={12} lg={6}>
                      <div>
                        <p>Practice</p>
                        <AutoCompleteDoctor
                          clinicGuid={clinic}
                          filter={doctorsFilter}
                          handleClick={onDoctorChange}
                        />
                      </div>
                    </Col>
                  )}
                </div>
              </Col>
              <Col xs={12} lg={8}>
                <Row>
                  <Col xs={12} lg={6}>
                    <InsTypeChart insuranceBlocks={insuranceBlocks} />
                  </Col>
                  <Col xs={12} lg={6}>
                    <FulfillmentChart statusBlocks={statusBlocks} />
                  </Col>
                </Row>
              </Col>
            </Row>
            <div className="performance-review__header-icon">
              {withLoader(
                patients.length < 0 || csvLoading,
                <button onClick={sendReport}>
                  <DownloadRoundedIcon className="performance-review__header-icon-svg" />
                  <br />
                  <span>Download</span>
                </button>,
              )}
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

practiceStats.propTypes = {
  statusBlocks: PropTypes.object.isRequired,
  insuranceBlocks: PropTypes.array.isRequired,
  patients: PropTypes.array,
};

export default practiceStats;
